import { Action, Module, Mutation,
  VuexModule } from 'vuex-module-decorators';
import { changePassword, deleteUser, sendUpdateUserPhoneVerify,
  uploadData, uploadEmail, uploadPhone, uploadPhoto } from '@/services/api';
import { GenderEnum } from '@/types';
import { getLoggedUser } from '@/services/api';
import { iUser } from '@/types';

const DELETE_USER = 'DELETE_USER';
const LOGOUT_USER = 'LOGOUT_USER';
const SET_USER = 'SET_USER';
const UPLOAD_USER_DATA = 'UPLOAD_USER_DATA';
const UPLOAD_USER_IMG = 'UPLOAD_USER_IMG';

@Module({namespaced: true})
export default class User extends VuexModule {
  public user: iUser = {
    id: 0,
    username: '',
    first_name: '',
    middle_name: '',
    last_name: '',
    birthday: null,
    gender: GenderEnum.n,
    email: '',
    phone: '',
    photo: '',
    passports: [],
    taxpayer_id: '',
    is_email_proved: false,
    is_phone_proved: false,
    is_taxpayer_id_proved: false,
    is_agree_with_agreement: null,
    date_joined: null,
    last_login: null,
    activated_at: null,
    deleted_at: null,
  };
  public userLogged: boolean = false;

  @Mutation
  public [SET_USER](payload: iUser): void {
    this.userLogged = true;
    this.user = payload;
  }

  @Mutation
  public [UPLOAD_USER_IMG](payload: iUser): void {
    this.user = payload;
  }

  @Mutation
  public [UPLOAD_USER_DATA](payload): void {
    this.user.first_name = payload.first_name;
    this.user.last_name = payload.last_name;
    this.user.birthday = payload.birthday;
    this.user.gender = payload.gender;
  }

  @Mutation
  public [DELETE_USER](payload): void {
    this.user = {
      id: 0,
      username: '',
      first_name: '',
      middle_name: '',
      last_name: '',
      birthday: null,
      gender: GenderEnum.n,
      email: '',
      phone: '',
      photo: '',
      passports: [],
      taxpayer_id: '',
      is_email_proved: false,
      is_phone_proved: false,
      is_taxpayer_id_proved: false,
      is_agree_with_agreement: null,
      date_joined: null,
      last_login: null,
      activated_at: null,
      deleted_at: null,
    };
  }

  @Mutation
  public [LOGOUT_USER](): void {
    this.userLogged = false;
  }

  public get loggedUser() {
    return this.user;
  }

  public get logged() {
    return this.userLogged;
  }

  @Action
  public async loginByAccessToken() {
    const token = localStorage.getItem('token');
    if (token) {
      return await getLoggedUser();
    }
  }

  @Action({commit: SET_USER})
  public setUser(user) {
    return user;
  }

  @Action({commit: UPLOAD_USER_IMG})
  public async uploadUserImg(payload) {
    const data = await uploadPhoto(payload);
    return data.data;
  }

  @Action
  public async updateUserData(payload) {
    const data = await uploadData(payload);
    if (data.status === 200) {
      this.context.dispatch('rewriteUserData', data);
    } else {
      return data;
    }
  }

  @Action({commit: UPLOAD_USER_DATA})
  public async rewriteUserData(payload) {
    return payload.data;
  }

  @Action({})
  public async updateUserEmail(payload) {
    const data = await uploadEmail(payload);
    if (data.status === 200) {
      this.context.dispatch('setUser', data.data);
    } else {
      return data;
    }
  }

  @Action({})
  public async updateUserPhone(payload) {
    const data = await uploadPhone(payload);
    if (data.status === 200) {
      this.context.dispatch('setUser', data.data);
    } else {
      return data;
    }
  }

  @Action({commit: DELETE_USER})
  public async clearUserData() {
    const data = await deleteUser();
    this.context.dispatch('logout');
    return data;
  }

  @Action({commit: LOGOUT_USER})
  public logout() {
    localStorage.clear();
    return this.userLogged;
  }

  @Action({})
  public async userChangePassword(payload) {
    return changePassword(payload);
  }

}
